import React, { useContext, useEffect, useState } from 'react';
import { FormattedMessage } from 'react-intl';
import { Link } from 'react-router-dom';
import Header from '../../../containers/User/HeaderContainer';
import Grid from '../../Common/Grid';
import Paper from '../../Common/Paper';
import Container from '../../Common/Container';
import Box from '../../Common/Box';
import Typography from '../../Common/Typography';
import messages from './messages';
import useStyles from './styles';
import Button from '../../Common/Button';
import Footer from '../../Unknown/Footer';
import { TenantContext } from '../../../common/tenantContext';
import { AnalyticsContext } from '../../../common/analyticsContext';
import { AnalyticEventNames } from '../../../common/analyticEventNames.enum';
import { AuthContext } from '../../../common/authContext';
import TrialReminder from '../../Trial/TrialReminder/TrialReminder';

export default function WelcomeScreen() {
  const classes = useStyles();
  const { tenant } = useContext(TenantContext);
  const { authUser } = useContext(AuthContext);
  const { trackEvent } = useContext(AnalyticsContext);
  const { _id: tenantId, logoUrl } = tenant ?? {};
  const [isContextLoad, setIsContextLoad] = useState(false);

  useEffect(() => {
    if (tenantId) {
      setIsContextLoad(true);
    } else {
      setIsContextLoad(false);
    }
  }, [tenantId]);

  const realtorInfo = () => {
    return (
      <>
        <div className={classes.realtorInfo}>
          <div className={classes.realtorName}>
            {authUser?.firstName} {authUser?.lastName}
          </div>
        </div>
        <div className={classes.logoDivider}></div>
      </>
    );
  };

  return (
    <>
      {isContextLoad && (
        <>
          <Header />
          {authUser.status === 'trial' && (
            <TrialReminder reminderType="expiration" />
          )}
          <Container maxWidth="xl" component="div" disableGutters>
            <Grid
              className={classes.root}
              container
              justifyContent="center"
              alignItems="center"
            >
              <Grid item xs={11} sm={8} md={6} lg={5}>
                <Paper className={classes.paper} elevation={0} square>
                  <Typography variant="h5">
                    <Box mb={2}>
                      <FormattedMessage {...messages.title} />
                    </Box>
                  </Typography>
                  <div className={classes.brand}>
                    {authUser.status === 'trial' && realtorInfo()}
                    <div className={classes.logoWrapper}>
                      <img
                        className={classes.logo}
                        src={logoUrl}
                        alt="RealGenius logo"
                      />
                    </div>
                  </div>
                  <div className={classes.actions}>
                    <Button
                      size="large"
                      color="primary"
                      variant="contained"
                      component={Link}
                      to={`/dashboard/${tenant.name}`}
                      onClick={() => {
                        trackEvent(AnalyticEventNames.RealtorInteraction, {
                          realtorId: authUser?._id,
                          tenantId,
                          action: 'View clients'
                        });
                      }}
                    >
                      <FormattedMessage {...messages.viewClients} />
                    </Button>
                    <Button
                      size="large"
                      color="secondary"
                      variant="contained"
                      component={Link}
                      to="/clients/create"
                      onClick={() => {
                        trackEvent(AnalyticEventNames.RealtorInteraction, {
                          realtorId: authUser?._id,
                          tenantId,
                          action: 'Add new client'
                        });
                      }}
                    >
                      <FormattedMessage {...messages.addClient} />
                    </Button>
                  </div>
                </Paper>
              </Grid>
            </Grid>
            <Footer />
          </Container>
        </>
      )}
    </>
  );
}
